export default {
  tags: {
    identification: 'Identificación: {{id}}',
    createIdentification: 'Configurar Identificación',
  },
  tooltips: {
    identification:
      'Tu identificación facilitará el reconocimiento de tu cuenta cuando llamés a soporte.',
    createIdentification:
      'Tu identificación facilitará el reconocimiento de tu cuenta cuando llamés a soporte.',
  },

  new_support_model: {
    wizard_steps: {
      step1: 'Descripción de tu inquietud',
      step2: 'Ayudas relacionadas',
      step3: 'Opciones de contacto',
    },
    described_inquery: {
      title: 'Hola, {{name}}, ¿cómo podemos ayudarte?',
      title_without_name: 'Hola, ¿cómo podemos ayudarte?',
      subtitle: 'Describí tu inquietud de forma general y te ayudaré a resolverla.',
      cta_btn: 'Continuar',
      notification_chat:
        '<strong>¡Tenés un chat abierto!</strong> Continuá tu conversación con soporte.',
    },
    relationated_helps: {
      support_card: {
        title: '¿Aún no resolvés tu inquietud?',
        description: 'Explorá tus canales de soporte y contacta a nuestro equipo.',
      },
    },
    contact_options: {
      title: 'Opciones de contacto',
      subtitle: 'Estas son las opciones de soporte disponibles para tu plan',
      support_options: {
        chat: {
          title: 'Hablá con un agente por chat',
          // description: 'Hablá con uno de nuestros representantes a través de nuestro chat en vivo.',
          description_sales:
            'Disponible de lunes a viernes de 10:00am a 2:00pm y de 4:00pm a 7:30pm',
          description: 'Disponible de lunes a viernes de 8:00am a 12:30pm y de 2:00pm a 5:30pm',
          description_enterprise:
            // 'Disponible de lunes a viernes de 8:00am a 5:30pm y los sábados de 8:00 am a 12:30 pm <strong>hora colombiana</strong>',
            'Disponible de lunes a viernes de 10:00am a 7:30pm y los sábados de 10:00 am a 14:30 pm',
          description_acc: 'Disponible de lunes a viernes durante todo el día',
          description_sales_acc:
            'Disponible de lunes a viernes de 10:00am a 2:00pm y de 4:00pm a 7:30pm',
        },
        try_chat: {
          title: 'Hablá con un representante por chat',
          // description:'Chateá en vivo con nuestros representantes. ¡Probá gratis durante el primer mes!',
          description_sales:
            'Disponible de lunes a viernes de 10:00am a 2:00pm y de 4:00pm a 7:30pm <span style="color: #4F46E5;">¡Probá gratis durante los primeros 15 días!</span>',
          description:
            'Disponible de lunes a viernes de 7:30am a 1pm y de 2:00pm a 4:30pm <span style="color: #4F46E5;">¡Probá gratis durante los primeros 15 días!</span>',
        },
        group_training: {
          title: 'Agendá una capacitación grupal',
          description: 'Sumate a una sesión grupal y ampliá tus conocimientos en comunidad.',
        },
        individual_advice: {
          title: 'Agendá una asesoría individual',
          description:
            'Elegí el horario que mejor te convenga según tus necesidades y disponibilidad.',
        },
        send_email: {
          title: 'Mandá un correo',
          description:
            'Nuestra bandeja de entrada está <strong>disponible las 24 horas</strong> para resolver tus dudas.',
          step1: {
            subtitle:
              'Dejá tu duda o consulta por acá, y pronto un agente te ayudará a resolver tu caso.',
            file: {
              label:
                '¿Tenés capturas, documentos o imágenes? Cargalas acá, esto nos ayudará a identificar tu problema.',
              hint: 'Solo archivos JPG or PNG menores a 500mb',
            },
          },
          message_final: {
            title: '¡Correo enviado!',
            message: 'Nos pondremos en contacto muy pronto.',
            advice: 'Si no encuentras el correo, busca en la carpeta de Promociones o Spam.',
          },
        },
        whatsapp: {
          title: 'Escribinos por WhatsApp',
          description:
            'Recibí asistencia personalizada a través de WhatsApp. Disponible de lunes a viernes de 10:00 a.m a 2:00 p.m. y de 4:00 p.m a 7:30 p.m',
          description_enterprise:
            'Recibí asistencia personalizada a través de WhatsApp. Disponible de lunes a viernes de 10:00 a.m a 7:30 p.m',
          description_acc:
            'Recibí asistencia personalizada a través de WhatsApp. Disponible de lunes a viernes de 10:00 a.m a 2:00 p.m. y de 4:00 p.m a 7:30 p.m',
          description_sales:
            'Recibí asistencia personalizada a través de WhatsApp. Disponible de lunes a viernes de 10:00 a.m a 2:00 p.m. y de 4:00 p.m a 7:30 p.m',
          description_sales_acc:
            'Recibí asistencia personalizada a través de WhatsApp. Disponible de lunes a viernes de 10:00 a.m a 2:00 p.m. y de 4:00 p.m a 7:30 p.m',
          message_final: {
            title: 'Escribinos por WhatsApp',
            message: 'Escaneá el código QR para contactarnos usando la app en tu celular.',
            button: 'Escribir desde WhatsApp Web ',
          },
        },
        call_agent: {
          title: 'Llamá a un agente de soporte',
          description:
            'Disponible de lunes a viernes de 9:00 a.m. a 12:30 p.m. y de 2:00 p.m. a 5:30 p.m.',
          description_acc:
            'Disponible de lunes a viernes de 9:00 a.m. a 12:30 p.m. y de 2:00 p.m. a 5:30 p.m.',
          description_sales: 'Disponible de lunes a viernes de 8:30 a.m. a 3:30 p.m.',
          description_enterprise:
            'Disponible de lunes a viernes de 9:00 a.m. a 12:30 p.m. y de 2:00 p.m. a 5:30 p.m.',
          message_final: {
            title: 'Llamá al {{phone}} para hablar con un agente de soporte',
            message_sales: 'Disponible de lunes a viernes de 8:30 a.m. a 3:30 p.m.',
            message:
              'Disponible de lunes a viernes de 9:00 a.m. a 12:30 p.m. y de 2:00 p.m. a 5:30 p.m.',
          },
        },
        comunity_forum: {
          title: 'Consultá en el foro comunitario',
          description: 'Hacé preguntas y obtené respuestas de la comunidad de usuarios de Alegra.',
        },
      },
      banner_upsell: {
        title: 'Accedé a más opciones de soporte',
        description:
          'Mejorá tu plan y obtené acceso a más canales de soporte para recibir ayuda especializada cuando la necesites',
        ctas_btn: {
          upgrade: 'Actualizar plan',
          contact: 'Hablar con ventas',
        },
        modals: {
          contact: {
            title: 'Llama a un agente de Alegra',
            message_final: {
              title: 'Llama al {{phone}} y contacta a {{agent}} ',
              message: 'Disponible de lunes a viernes de 8:30 am a 3:30 pm',
              message_support: 'Disponible de lunes a viernes de 7:30 a.m. a 4:30 p.m.',
            },
          },
        },
      },
    },
  },
}
